import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'replaceString',
    standalone: false
})
export class ReplaceStringPipe implements PipeTransform {
    transform(value: string, args?: { old: string, new: string }): any {
        if (!args?.old || !args?.new) {
            return value;
        }
        return value.replace(args.old, args.new);
    }
}
